import { CollectionFilterRequest } from '../requests/collection-filter.request';
import { isNil, Nillable } from '@web/utils';
import { TableFilter } from '../../collection/types/table-filter';
import { FromTableTextCollectionFilterRequestBuilder } from './from-table-text-collection-filter-request.builder';
import { FromTableDateCollectionFilterRequestBuilder } from './from-table-date-collection-filter-request.builder';
import { FromTableBooleanCollectionFilterRequestBuilder } from './from-table-boolean-collection-filter-request.builder';

export class FromTableCollectionFilterRequestBuilder<Filter> {
  private _requests: CollectionFilterRequest[] = [];

  public constructor(private _tableFilter: Nillable<TableFilter<Filter>>) {}

  public reset(): this {
    this._requests = [];
    this._tableFilter = null;

    return this;
  }

  public appendText(
    factory: (
      builder: FromTableTextCollectionFilterRequestBuilder<Filter>,
    ) => Nillable<CollectionFilterRequest>,
  ): this {
    if (isNil(this._tableFilter)) {
      return this;
    }

    const result = factory(
      new FromTableTextCollectionFilterRequestBuilder<Filter>().fromTableFilter(
        this._tableFilter,
      ),
    );

    if (isNil(result)) {
      return this;
    }

    this._requests.push(result);

    return this;
  }

  public appendBoolean(
    factory: (
      builder: FromTableBooleanCollectionFilterRequestBuilder<Filter>,
    ) => Nillable<CollectionFilterRequest>,
  ): this {
    if (isNil(this._tableFilter)) {
      return this;
    }

    const result = factory(
      new FromTableBooleanCollectionFilterRequestBuilder<Filter>().fromTableFilter(
        this._tableFilter,
      ),
    );

    if (isNil(result)) {
      return this;
    }

    this._requests.push(result);

    return this;
  }

  public appendDate(
    factory: (
      builder: FromTableDateCollectionFilterRequestBuilder<Filter>,
    ) => Nillable<CollectionFilterRequest>,
  ): this {
    if (isNil(this._tableFilter)) {
      return this;
    }

    const result = factory(
      new FromTableDateCollectionFilterRequestBuilder<Filter>().fromTableFilter(
        this._tableFilter,
      ),
    );

    if (isNil(result)) {
      return this;
    }

    this._requests.push(result);

    return this;
  }

  public buildAsArray(): CollectionFilterRequest[] {
    const result = [...this._requests];

    this.reset();

    return result;
  }
}
